module.exports = __webpack_public_path__ + "img/shouhaizhe.7a151a2f.png";